// vestahome.ge — "განვადებით ყიდვის" ღილაკების ლოგიკა.
// ორი რეჟიმი: "product" (ერთი პროდუქტი, პროდუქტის გვერდზე) და
// "cart" (მთელი კალათა, cart გვერდზე — Shopify-ს /cart.js-იდან იკითხავს).
// ორივე შემთხვევაში აგზავნის items-ს ჩვენს backend-ზე (POST /api/checkout/start),
// რომელიც ქმნის Shopify Draft Order-ს + ბანკის შეკვეთას და აბრუნებს redirect ბმულს.

(function () {
  var BACKEND_URL = 'https://vestahome-installments.onrender.com';
  if (window.fetch) fetch(BACKEND_URL + '/', { mode: 'no-cors' }).catch(Boolean); // VH: სერვერის წინასწარ გაღვიძება
  // ერთი საერთო, სრულეკრანიანი overlay — რომ მომხმარებელმა ცხადად დაინახოს,
  // რომ გადამისამართება რამდენიმე წამში მოხდება, და ამასობაში ვერაფერზე
  // დააჭიროს (overlay-ს ვერაფერი "ეხედება" ქვემოთ, keyboard/click დაბლოკილია).
  function getOverlay() {
    var el = document.getElementById('installment-overlay');
    if (el) return el;
    el = document.createElement('div');
    el.id = 'installment-overlay';
    el.className = 'installment-overlay';
    el.hidden = true;
    el.innerHTML =
      '<div class="installment-overlay__box">' +
      '<div class="installment-overlay__spinner" aria-hidden="true"></div>' +
      '<p class="installment-overlay__text">გთხოვთ მოიცადოთ...</p>' +
      '<p class="installment-overlay__subtext">რამდენიმე წამში გადაგამისამართებთ ბანკის გვერდზე — გვერდი არ დახუროთ და არ დააჭიროთ სხვა ღილაკებს.</p>' +
      '</div>';
    document.body.appendChild(el);
    return el;
  }

  function showOverlay() {
    getOverlay().hidden = false;
  }

  function hideOverlay() {
    var el = document.getElementById('installment-overlay');
    if (el) el.hidden = true;
  }

  function findVariantId(widget) {
    var scope = widget.closest('.product, [data-product], body') || document;
    var input = scope.querySelector('form[action*="/cart/add"] [name="id"]') || document.querySelector('[name="id"]');
    return input ? input.value : widget.getAttribute('data-variant-id');
  }

  function findQuantity(widget) {
    var scope = widget.closest('.product, [data-product], body') || document;
    var input = scope.querySelector('[name="quantity"]') || document.querySelector('[name="quantity"]');
    var qty = input ? parseInt(input.value, 10) : 1;
    return Number.isFinite(qty) && qty > 0 ? qty : 1;
  }

  function buildProductItems(widget) {
    var variantId = parseInt(findVariantId(widget), 10);
    var price = parseFloat(widget.getAttribute('data-price'));
    if (!variantId || !price) return null;
    return [
      {
        variantId: variantId,
        productId: widget.getAttribute('data-product-id'),
        title: widget.getAttribute('data-product-title'),
        quantity: findQuantity(widget),
        price: price,
      },
    ];
  }

  // კალათის რეჟიმისთვის — Shopify-ს საკუთარი /cart.js AJAX endpoint-იდან
  // ვკითხულობთ ყველა ამჟამინდელ line item-ს.
  function fetchCartItems() {
    return fetch('/cart.js')
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        if (!cart.items || cart.items.length === 0) return null;
        return cart.items.map(function (li) {
          return {
            variantId: li.variant_id,
            productId: li.product_id,
            title: li.product_title,
            quantity: li.quantity,
            price: li.price / 100, // Shopify /cart.js ფასს თეთრებში აბრუნებს
          };
        });
      });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.installment-btn');
    if (!btn) return;

    var widget = btn.closest('[data-installment-widget]');
    if (!widget) return;
    var statusEl = widget.querySelector('.installment-status');
    var bank = btn.getAttribute('data-bank');
    var mode = widget.getAttribute('data-mode') || 'product';

    var allButtons = widget.querySelectorAll('.installment-btn');

    function fail(message) {
      hideOverlay();
      if (statusEl) {
        statusEl.hidden = false;
        statusEl.textContent = message;
      }
      allButtons.forEach(function (b) {
        b.disabled = false;
      });
    }

    function proceed(items) {
      if (!items || items.length === 0) {
        fail(mode === 'cart' ? 'კალათა ცარიელია.' : 'ვერ დადგინდა პროდუქტის ვარიანტი — სცადეთ გვერდის განახლება.');
        return;
      }

      allButtons.forEach(function (b) {
        b.disabled = true;
      });
      showOverlay();

      fetch(bank === 'tbc' ? 'https://vesta-tbc.vestahomegeorgia.workers.dev/api/tbc/start' : BACKEND_URL + '/api/checkout/start', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ bank: bank, items: items }),
      })
        .then(function (res) {
          return res.json().then(function (data) {
            if (!res.ok) throw new Error(data.error || 'უცნობი შეცდომა');
            return data;
          });
        })
        .then(function (data) {
          // overlay-ს განზრახ არ ვმალავთ — გვერდი ისედაც ტოვებს ამ საიტს.
          window.location.href = data.redirectUrl;
        })
        .catch(function (err) {
          fail('ვერ მოხერხდა: ' + err.message);
        });
    }

    if (mode === 'cart') {
      allButtons.forEach(function (b) {
        b.disabled = true;
      });
      showOverlay();
      fetchCartItems()
        .then(proceed)
        .catch(function (err) {
          fail('კალათის წაკითხვა ვერ მოხერხდა: ' + err.message);
        });
    } else {
      proceed(buildProductItems(widget));
    }
  });
})();
// ===== VH checkout: საკუთარი გადახდის ფორმა („ყიდვა“ / კალათის „გადახდა“) =====
// ორი ვარიანტი: სრულად ბარათით, ან კურიერთან გადახდა (ბარათით მხოლოდ საგარანტიო თანხა).
(function () {
  var ON = 1;
  var API = 'https://vesta-tbc.vestahomegeorgia.workers.dev/api/order/start';
  // კურიერთან გადახდა ჯერ მხოლოდ სატესტოდ: ჩანს მხოლოდ ?vhcod=1-ით. ყველასთვის ჩასართავად COD_ON = 1.
  var COD_ON = 1;
  try {
    if (/[?&]vhco=1/.test(location.search)) sessionStorage.setItem('vhCo', '1');
    if (/[?&]vhco=0/.test(location.search)) sessionStorage.removeItem('vhCo');
    if (sessionStorage.getItem('vhCo') === '1') ON = true;
    if (/[?&]vhcod=1/.test(location.search)) sessionStorage.setItem('vhCod', '1');
    if (/[?&]vhcod=0/.test(location.search)) sessionStorage.removeItem('vhCod');
    if (sessionStorage.getItem('vhCod') === '1') COD_ON = 1;
  } catch (e) {}
  if (!ON) return;

  var CSS =
    '#vhco{position:fixed;inset:0;z-index:2147483000;background:#f6f6f7;overflow:auto;color:#222;-webkit-overflow-scrolling:touch}' +
    '#vhco *{box-sizing:border-box;font-family:inherit}' +
    '.vhco-top{background:#fff;border-bottom:1px solid #eee;padding:12px 20px;display:flex;justify-content:center}' +
    '.vhco-top img{height:34px;width:auto}' +
    '.vhco-wrap{max-width:560px;margin:20px auto 40px;padding:0 16px}' +
    '.vhco-back{display:inline-block;background:none;border:0;color:#555;font-size:14px;margin:0 0 12px;padding:0;cursor:pointer}' +
    '.vhco-card{background:#fff;border-radius:16px;padding:20px;margin-bottom:14px;box-shadow:0 1px 3px rgba(0,0,0,.06)}' +
    '.vhco-h{font-size:18px;font-weight:700;margin:0 0 14px}' +
    '.vhco-item{display:flex;gap:14px;align-items:center;margin-top:10px}' +
    '.vhco-item:first-of-type{margin-top:0}' +
    '.vhco-item img{width:64px;height:64px;object-fit:contain;border:1px solid #eee;border-radius:12px;background:#fff;flex:none}' +
    '.vhco-item .t{flex:1;font-size:14px;line-height:1.35}' +
    '.vhco-item .q{color:#777;font-size:13px;margin-top:3px}' +
    '.vhco-item .pr{font-weight:700;white-space:nowrap}' +
    '.vhco-f{display:block;margin-bottom:14px}' +
    '.vhco-f span{display:block;font-size:14px;font-weight:700;color:#222;margin:0 0 6px 2px}' +
    '.vhco-f input{width:100%;border:1.5px solid #dcdcdc;border-radius:10px;padding:12px 14px;font-size:16px;background:#fff;outline:none;margin:0;color:#222}' +
    '.vhco-f input::placeholder{color:#b5b5b5;opacity:1;font-weight:400}' +
    '.vhco-f input:focus{border-color:#e2231a}' +
    '.vhco-f input.bad{border-color:#e2231a;background:#fff6f5}' +
    '.vhco-ph{display:flex;gap:8px}' +
    '.vhco-ph b{border:1.5px solid #dcdcdc;border-radius:10px;padding:12px;font-weight:600;color:#444;background:#fafafa}' +
    '.vhco-row{display:flex;justify-content:space-between;gap:12px;font-size:15px;margin:8px 0}' +
    '.vhco-free{color:#1a8f3c;font-weight:600}' +
    '.vhco-tot{border-top:1px solid #eee;margin-top:12px;padding-top:12px;font-size:18px;font-weight:700}' +
    '.vhco-pay{display:block;border:1.5px solid #dcdcdc;border-radius:12px;padding:14px 14px 14px 44px;margin-top:10px;cursor:pointer;position:relative;background:#fff;transition:border-color .15s,background .15s}' +
    '.vhco-pay:first-of-type{margin-top:0}' +
    '.vhco-pay input{position:absolute;left:14px;top:16px;width:18px;height:18px;margin:0;accent-color:#e31837}' +
    '.vhco-pay.on{border-color:#e31837;background:#fff8f8}' +
    '.vhco-pay .pt{display:block;font-size:15px;font-weight:700}' +
    '.vhco-pay .ps{display:block;font-size:13.5px;color:#666;margin-top:4px;line-height:1.45}' +
    '.vhco-pay .ps b{color:#222}' +
    '.vhco-cod{display:none;margin-top:12px}' +
    '.vhco-cod.on{display:block}' +
    '.vhco-cod .vhco-row b{white-space:nowrap}' +
    '.vhco-cod .now{color:#e31837}' +
    '.vhco-terms{background:#fafafa;border-radius:10px;padding:10px 12px;font-size:13px;color:#555;line-height:1.5;margin:10px 0 0}' +
    '.vhco-btn{display:block;width:100%;min-height:52px;background:#e31837;color:#fff;border:.8px solid #000;border-radius:8px;padding:12px 24px;font-size:16px;font-weight:600;line-height:1.2;margin-top:8px;cursor:pointer;transition:background .2s ease,box-shadow .2s ease}' +
    '.vhco-btn:hover:not([disabled]){background:#c8102e;box-shadow:0 4px 14px rgba(227,24,55,.3)}' +
    '.vhco-btn[disabled]{opacity:.65;cursor:wait}' +
    '.vhco-err{display:none;background:#fff1f0;color:#b3261e;border-radius:10px;padding:10px 12px;font-size:14px;margin-top:10px}' +
    '.vhco-note{text-align:center;font-size:12.5px;color:#777;margin-top:10px}';

  function money(t) {
    return (t / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' ₾';
  }
  // საგარანტიო თანხა (თეთრებში), მრგვალ ლარამდე. Worker-ში ზუსტად იგივე ფორმულაა.
  //   200 ₾-მდე (ჩათვლით) — 30 ₾;  200 ₾-ზე მეტი — 50 ₾;  როცა 10% 50 ₾-ს აჭარბებს — 10%.
  var COD_MIN = 10000; // 100 ₾-ზე ნაკლებ შეკვეთაზე კურიერთან გადახდა არ ჩანს — მხოლოდ სრულად ბარათით.
  function depositOf(total) {
    if (total <= 20000) return 3000;
    return Math.max(5000, Math.round(total / 1000) * 100);
  }
  function el(tag, cls, text) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (text != null) e.textContent = text;
    return e;
  }
  function load(k) {
    try { return JSON.parse(localStorage.getItem('vhCoCust') || '{}')[k] || ''; } catch (e) { return ''; }
  }
  function save(c) {
    try { localStorage.setItem('vhCoCust', JSON.stringify(c)); } catch (e) {}
  }

  function productItems() {
    var form = document.querySelector('form[action*="/cart/add"]');
    var idInput = form && form.querySelector('[name="id"]');
    var qInput = document.querySelector('[name="quantity"]');
    var vid = idInput ? parseInt(idInput.value, 10) : 0;
    var qty = qInput ? parseInt(qInput.value, 10) : 1;
    if (!vid) return Promise.resolve(null);
    var path = location.pathname.replace(/\/$/, '');
    return fetch(path + '.js').then(function (r) { return r.json(); }).then(function (p) {
      var v = (p.variants || []).filter(function (x) { return x.id === vid; })[0] || p.variants[0];
      var img = (v.featured_image && v.featured_image.src) || p.featured_image || '';
      var title = p.title + (v.title && v.title !== 'Default Title' ? ' — ' + v.title : '');
      qty = qty > 0 ? qty : 1;
      return [{ variantId: v.id, quantity: qty, title: title, image: img, line: v.price * qty }];
    });
  }

  function cartItems() {
    return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
      if (!c.items || !c.items.length) return null;
      return c.items.map(function (i) {
        return {
          variantId: i.variant_id,
          quantity: i.quantity,
          title: i.product_title + (i.variant_title ? ' — ' + i.variant_title : ''),
          image: i.image || '',
          line: i.final_line_price,
        };
      });
    });
  }

  function open(items) {
    if (!document.getElementById('vhco-css')) {
      var st = el('style');
      st.id = 'vhco-css';
      st.textContent = CSS;
      document.head.appendChild(st);
    }
    var old = document.getElementById('vhco');
    if (old) old.remove();

    var total = items.reduce(function (s, i) { return s + i.line; }, 0);
    var deposit = depositOf(total);
    var rest = total - deposit;
    var pay = 'full';

    var root = el('div');
    root.id = 'vhco';
    var top = el('div', 'vhco-top');
    var logoSrc = (document.querySelector('.header__heading-logo, header img') || {}).src;
    if (logoSrc) {
      var lg = el('img');
      lg.src = logoSrc;
      lg.alt = 'Vesta Home';
      top.appendChild(lg);
    } else top.appendChild(el('b', null, 'Vesta Home'));
    root.appendChild(top);

    var wrap = el('div', 'vhco-wrap');
    root.appendChild(wrap);
    var back = el('button', 'vhco-back', '‹ დაბრუნება');
    back.type = 'button';
    back.onclick = close;
    wrap.appendChild(back);

    // 1) შეკვეთა
    var c1 = el('div', 'vhco-card');
    c1.appendChild(el('p', 'vhco-h', 'შეკვეთა'));
    items.forEach(function (i) {
      var row = el('div', 'vhco-item');
      var im = el('img');
      im.src = i.image ? String(i.image).replace(/^\/\//, 'https://') : '';
      im.alt = '';
      row.appendChild(im);
      var t = el('div', 't', i.title);
      t.appendChild(el('div', 'q', 'რაოდენობა: ' + i.quantity));
      row.appendChild(t);
      row.appendChild(el('div', 'pr', money(i.line)));
      c1.appendChild(row);
    });
    wrap.appendChild(c1);

    // 2) მიწოდების მონაცემები
    var c2 = el('form', 'vhco-card');
    c2.noValidate = true;
    c2.appendChild(el('p', 'vhco-h', 'მიწოდების მონაცემები'));
    function field(label, name, ph, type, prefix) {
      var l = el('label', 'vhco-f');
      l.appendChild(el('span', null, label));
      var inp = el('input');
      inp.name = name;
      inp.placeholder = ph;
      inp.type = type || 'text';
      inp.value = load(name);
      if (name === 'phone') { inp.inputMode = 'tel'; inp.autocomplete = 'tel-national'; }
      if (name === 'name') inp.autocomplete = 'name';
      if (name === 'city') inp.autocomplete = 'address-level2';
      if (name === 'address') inp.autocomplete = 'street-address';
      if (prefix) {
        var ph2 = el('div', 'vhco-ph');
        ph2.appendChild(el('b', null, prefix));
        ph2.appendChild(inp);
        l.appendChild(ph2);
      } else l.appendChild(inp);
      c2.appendChild(l);
      return inp;
    }
    var fName = field('სახელი და გვარი', 'name', 'მაგ. გიორგი ბერიძე');
    var fPhone = field('ტელეფონი', 'phone', '5XX XX XX XX', 'tel', '+995');
    var fCity = field('ქალაქი / მუნიციპალიტეტი', 'city', 'მაგ. თბილისი ან გურჯაანის მუნიციპალიტეტი');
    var fAddr = field('მისამართი', 'address', 'სოფელი ან ქუჩა, სახლი, ბინა');
    fAddr.parentNode.style.marginBottom = '0';

    // 3) გადახდის მეთოდი
    var cPay = el('div', 'vhco-card');
    cPay.appendChild(el('p', 'vhco-h', 'გადახდის მეთოდი'));
    function option(value, title, sub) {
      var l = el('label', 'vhco-pay');
      var r = el('input');
      r.type = 'radio';
      r.name = 'vhco-pay';
      r.value = value;
      l.appendChild(r);
      l.appendChild(el('span', 'pt', title));
      var s = el('span', 'ps');
      s.innerHTML = sub;
      l.appendChild(s);
      cPay.appendChild(l);
      return { label: l, input: r };
    }
    var oFull = option('full', 'სრულად ბარათით', 'გადაიხდით <b>' + money(total) + '</b>');
    var oCod = option(
      'cod',
      'კურიერთან გადახდა',
      'ახლა ბარათით: <b>' + money(deposit) + '</b> (საგარანტიო თანხა)<br>კურიერთან: <b>' + money(rest) + '</b>'
    );
    var codAllowed = COD_ON && total >= COD_MIN;
    if (!codAllowed) oCod.label.style.display = 'none';
    if (COD_ON && !codAllowed) cPay.appendChild(el('div', 'vhco-note', 'კურიერთან გადახდა ხელმისაწვდომია 100 ₾-დან'));

    var codBox = el('div', 'vhco-cod');
    codBox.appendChild(
      el(
        'div',
        'vhco-terms',
        'საგარანტიო თანხა ადასტურებს შეკვეთას და ჩაითვლება პროდუქტის ფასში. შეკვეთაზე უარის თქმის შემთხვევაში საგარანტიო თანხა არ ბრუნდება. გადახდით ეთანხმებით ამ პირობას.'
      )
    );
    cPay.appendChild(codBox);

    // 4) ჯამი + ღილაკი
    var c3 = el('div', 'vhco-card');
    function line(a, b, cls) {
      var r = el('div', 'vhco-row' + (cls ? ' ' + cls : ''));
      r.appendChild(el('span', null, a));
      var s = el('span', null, b);
      r.appendChild(s);
      c3.appendChild(r);
      return { row: r, val: s };
    }
    line('პროდუქცია', money(total));
    line('მიწოდება', 'უფასო').val.className = 'vhco-free';
    line('სულ', money(total), 'vhco-tot');
    var lNow = line('ახლა ბარათით (საგარანტიო)', money(deposit));
    var lRest = line('კურიერთან მიწოდებისას', money(rest));
    lNow.val.style.fontWeight = '700';
    lNow.val.style.color = '#e31837';
    lNow.row.style.display = lRest.row.style.display = 'none';

    var btn = el('button', 'vhco-btn');
    btn.type = 'button';
    c3.appendChild(btn);
    var err = el('div', 'vhco-err');
    c3.appendChild(err);
    c3.appendChild(el('div', 'vhco-note', '🔒 გადახდა ხდება ბანკის დაცულ გვერდზე · VISA · Mastercard'));

    wrap.appendChild(c2);
    wrap.appendChild(cPay);
    wrap.appendChild(c3);

    function btnText() {
      return pay === 'cod' ? 'საგარანტიოს გადახდა · ' + money(deposit) : 'გადახდა ბარათით · ' + money(total);
    }
    function setPay(v) {
      pay = v;
      oFull.input.checked = v === 'full';
      oCod.input.checked = v === 'cod';
      oFull.label.classList.toggle('on', v === 'full');
      oCod.label.classList.toggle('on', v === 'cod');
      codBox.classList.toggle('on', v === 'cod');
      lNow.row.style.display = lRest.row.style.display = v === 'cod' ? '' : 'none';
      btn.textContent = btnText();
      err.style.display = 'none';
    }
    oFull.input.onchange = function () { setPay('full'); };
    oCod.input.onchange = function () { setPay('cod'); };
    setPay('full');

    function fail(msg) {
      err.textContent = msg;
      err.style.display = 'block';
      btn.disabled = false;
      btn.textContent = btnText();
    }

    function submit() {
      err.style.display = 'none';
      var cust = {
        name: fName.value.trim(),
        phone: fPhone.value.replace(/\D/g, '').replace(/^995/, ''),
        city: fCity.value.trim(),
        address: fAddr.value.trim(),
      };
      var bad = [];
      if (cust.name.length < 2) bad.push(fName);
      if (!/^5\d{8}$/.test(cust.phone)) bad.push(fPhone);
      if (cust.city.length < 2) bad.push(fCity);
      if (cust.address.length < 4) bad.push(fAddr);
      [fName, fPhone, fCity, fAddr].forEach(function (i) { i.classList.toggle('bad', bad.indexOf(i) >= 0); });
      if (bad.length) {
        bad[0].focus();
        return fail(bad[0] === fPhone ? 'ჩაწერეთ სწორი მობილურის ნომერი (5XX XX XX XX).' : 'შეავსეთ ყველა ველი.');
      }
      save(cust);
      btn.disabled = true;
      btn.textContent = 'გთხოვთ მოიცადოთ...';
      fetch(API, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: items.map(function (i) { return { variantId: i.variantId, quantity: i.quantity }; }),
          customer: cust,
          pay: pay,
          agree: pay === 'cod' ? true : undefined,
        }),
      })
        .then(function (r) {
          return r.json().then(function (d) {
            if (!r.ok || !d.redirectUrl) throw new Error(d.error || 'შეცდომა');
            return d;
          });
        })
        .then(function (d) { location.href = d.redirectUrl; })
        .catch(function (e) { fail(e.message || 'ვერ მოხერხდა, სცადეთ თავიდან.'); });
    }
    btn.onclick = submit;
    c2.onsubmit = function (e) { e.preventDefault(); submit(); };

    document.body.appendChild(root);
    document.documentElement.style.overflow = 'hidden';
    try { history.pushState({ vhco: 1 }, ''); } catch (e) {}
  }

  function close() {
    var r = document.getElementById('vhco');
    if (r) r.remove();
    document.documentElement.style.overflow = '';
  }

  window.addEventListener('popstate', function () {
    if (document.getElementById('vhco')) close();
  });

  document.addEventListener(
    'click',
    function (e) {
      var t = e.target;
      var buy = t.closest && t.closest('.shopify-payment-button__button');
      var chk = t.closest && t.closest('button[name="checkout"], a[href="/checkout"], input[name="checkout"]');
      if (!buy && !chk) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      var src = buy ? productItems() : cartItems();
      src
        .then(function (items) {
          if (items && items.length) open(items);
          else location.href = '/cart';
        })
        .catch(function () { location.href = buy ? location.href : '/checkout'; });
    },
    true
  );
})();
